import {omit} from "lodash";
import {
  convertJsonSchemaToShorthandIfPossible
} from "../../../json/schema/convert-json-schema-to-shorthand-if-possible";
import {ProophBoardDescriptionKeys} from "../../descriptions";
import {AnyRule} from "../../rule-definitions";
import {PlayEventRuntimeInfo} from "./event-definitions";

export const prepareDiffEvent = (event: PlayEventRuntimeInfo, applyRules?: AnyRule[]): object => {
  return {
    desc: omit(event.desc, ProophBoardDescriptionKeys),
    schema: convertJsonSchemaToShorthandIfPossible(event.schema),
    factory: event.factory,
    applyRules
  }
}
